// app/javascript/controllers/infinite_scroll_controller.js
import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Conecta em um container que fica DENTRO do turbo-frame "users_next_page"
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.loading = false
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.load()
        })
      },
      { root: null, rootMargin: "200px 0px", threshold: 0 } // pré-carrega ~200px antes de chegar
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  load() {
    if (this.loading) return
    this.loading = true

    get(this.urlValue, {
      responseKind: 'turbo-stream'
    })
    // // Navega o PRÓPRIO turbo-frame pai para a próxima URL
    // const frame = this.element.closest("turbo-frame")
    // if (frame && this.hasUrlValue) {
    //   // Mostra um 'loading' simples enquanto carrega
    //   this.element.innerHTML = `<span class="text-muted">Carregando…</span>`
    //   frame.src = this.urlValue
    // } else {
    //   // Fallback: clica no primeiro link dentro (deve apontar p/ a próxima página)
    //   const link = this.element.querySelector("a")
    //   if (link) link.click()
    // }
  }
}

